import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

// ============================================================================
// Types
// ============================================================================

export interface YearSelectorProps {
    titleId: string;
    years?: string[];
    currentYear: string;
    onYearChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

// ============================================================================
// Styled Components
// ============================================================================

const StyledSelect = styled.select`
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.gray8};
    border-radius: 4px;
    font-size: 14px;
    margin-left: 8px;
    cursor: pointer;
    
    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primary};
    }
`;

const Container = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Label = styled.label`
    font-size: 14px;
    color: ${({ theme }) => theme.gray3};
`;

// ============================================================================
// Component
// ============================================================================

const YearSelector: React.FC<YearSelectorProps> = ({ years = [], currentYear, onYearChange, titleId }) => {
    const yearsToDisplay = years.length === 0 ? [currentYear] : years;

    return (
        <Container>
            <Label htmlFor="application_year">
                <FormattedMessage id={titleId} />
            </Label>
            <StyledSelect id="application_year" value={currentYear} onChange={onYearChange}>
                {yearsToDisplay.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </StyledSelect>
        </Container>
    );
};

export default YearSelector;
